import { IUser } from '.';
import { UsersActionKeys as keys } from './usersActionKeys';

export const usersActionCreators = {
  setUsers: (users: IUser[]) => ({ payload: users, type: keys.SET_USERS } as const)
};

export type usersActionTypes = ReturnType<typeof usersActionCreators.setUsers>;
